import React from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

type PagePaperProps = {
  title?: string;
  description?: string;
  belowTitle?: string;
  belowDescription?: string;
  children?: React.ReactNode;
};

function PagePaper(props: PagePaperProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: { xs: "300px", sm: "400px" },
        gap: 2,
      }}
    >
      {props.description && (
        <Typography variant="body1" sx={{ textAlign: "center", px: 1 }}>
          {props.description}
        </Typography>
      )}
      <Paper
        elevation={0}
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          flexShrink: 0,
          width: { xs: "300px", sm: "400px" },
          gap: 2,
        }}
      >
        {props.title && (
          <Typography variant="h6" sx={{ color: "info.main", fontWeight: 500, alignSelf: "center" }}>
            {props.title}
          </Typography>
        )}
        {props.children}
      </Paper>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
        {props.belowTitle && (
          <Typography variant="body1" sx={{ textAlign: "center", fontWeight: 500, px: 1 }}>
            {props.belowTitle}
          </Typography>
        )}
        {props.belowDescription && (
          <Typography variant="body1" sx={{ textAlign: "center", px: 1 }}>
            {props.belowDescription}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default PagePaper;
